import React from "react";
import {
  Container,
  ContentContainer,
  ImgContainer,
  LinksContainer,
  TechsContainer,
} from "./style";
import { AiFillGithub } from "react-icons/ai";
import { TbWorld } from "react-icons/tb";

export const ProjectCard = ({ project }) => {
  const { img, title, description, techs, github, vercel } = project;
  console.log(github);
  return (
    <Container>
      <ImgContainer>
        <img src={img} alt="" />
      </ImgContainer>
      <ContentContainer>
        <h2>{title}</h2>
        <p>{description}</p>
      </ContentContainer>
      <TechsContainer>
        <h3>Tecnologias Usadas:</h3>
        <ul>
          {techs?.map((tech, index) => (
            <li key={index}>{tech}</li>
          ))}
        </ul>
      </TechsContainer>
      <LinksContainer>
        <a href={github} target="_blank" rel="noopener noreferrer">
          <AiFillGithub size={42} />
        </a>
        <a href={vercel} target="_blank" rel="noopener noreferrer">
          <TbWorld size={42} />
        </a>
      </LinksContainer>
    </Container>
  );
};
